import { FC } from 'react';
import { Button } from '../../../../components/shared/button/Button';
import strings from '../../team.translations';

interface FormActionButtonsProps {
  loading?: boolean;
  onCancel: () => void;
}

export const FormActionButtons: FC<FormActionButtonsProps> = ({ loading, onCancel }) => {
  return (
    <div className="space-y-5 max-w-3xl mx-auto mb-4pt-5 pl-5">
      <div className="flex w-full items-center justify-end gap-5">
        <Button onClick={onCancel}>{strings.common.cancel}</Button>
        <Button primary type="submit" loading={loading}>
          {strings.common.save}
        </Button>
      </div>
    </div>
  );
};
